import * as React from 'react';

import './styles.css';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';
import { Message } from 'semantic-ui-react';

export interface Props {
  message: string;
  showErrorPrefix: boolean;
}

const spaceChar: string = '\x20';

// tslint:disable-next-line:no-any
export const ErrorMessage: React.StatelessComponent<any> = (props) => {
    const i18n = getI18n();
    const errorMessage = props.message
        ? (
            <Message color="red" className="error-message">
                <Message.Content>
                    {
                      props.showErrorPrefix
                        ? i18n.t(translations.Error) + ':' + spaceChar
                        : null
                    }
                    {props.message}
                </Message.Content>
            </Message>
        )
        : null;
    return errorMessage;
};

ErrorMessage.defaultProps = {
  showErrorPrefix: true
};


// WEBPACK FOOTER //
// ./src/components/error-message/index.tsx